export default "__VITE_ASSET__pmsV9u62__"